import "./ProductListElement";

import { ProductStore } from "./ProductStore";

var productStore = ProductStore.instance;

export { productStore };